export enum BoksExpectedReason {
  VALID_HEX_CHAR = 'VALID_HEX_CHAR',
  PIN_CODE_FORMAT = 'PIN_CODE_FORMAT',
  EXACT_LENGTH = 'EXACT_LENGTH',
  MIN_LENGTH = 'MIN_LENGTH',
  MAX_LENGTH = 'MAX_LENGTH',
  KNOWN_OPCODE = 'KNOWN_OPCODE',
  CONFIG_KEY_FORMAT = 'CONFIG_KEY_FORMAT',
  POSITIVE_INTEGER = 'POSITIVE_INTEGER',
  MAC_ADDRESS_FORMAT = 'MAC_ADDRESS_FORMAT',
  NFC_UID_FORMAT = 'NFC_UID_FORMAT',
  UINT8 = 'UINT8',
  UINT16 = 'UINT16',
  UINT32 = 'UINT32',
  UINT8_ARRAY = 'UINT8_ARRAY',
  OBJECT = 'OBJECT',
  FUNCTION = 'FUNCTION',
  CONSTRUCTOR = 'CONSTRUCTOR',
  NUMBER = 'NUMBER',
  BUFFER_SIZE = 'BUFFER_SIZE',
  BIT_INDEX = 'BIT_INDEX'
}
